import { type ComponentProps, memo } from 'react';

import { Skeleton } from '@air/component-skeleton';
import { cn } from '@air/utils-tailwind';

export type AssetVersionSkeletonInfoProps = Omit<ComponentProps<'div'>, 'children'>;

export const AssetVersionSkeletonInfo = memo(({ className, ...restOfProps }: AssetVersionSkeletonInfoProps) => {
  return (
    <div className={cn('flex flex-col gap-0.5', className)} data-testid="ASSET_VERSION_SKELETON_INFO" {...restOfProps}>
      <Skeleton className="ads:text-ads-gray-6 text-gray-6" height={18} width={64} isText />
      <Skeleton className="ads:text-ads-gray-6 text-gray-6" height={18} width={120} isText />
    </div>
  );
});

AssetVersionSkeletonInfo.displayName = 'AssetVersionSkeletonInfo';
